import React from 'react';
import loadable from '@loadable/component';
import Loading from '%app/js/common/components/material/Loading';
import navigateToPaymentGateway from '../services/navigateToPaymentGateway';

const AsyncHomePage = loadable(
    () => import('../pages/HomePage'),
    { fallback: <Loading /> },
);

const AsyncEventDetailPage = loadable(
    () => import('../pages/EventDetailPage'),
    { fallback: <Loading /> },
);

const AsyncEventGroupDetailPage = loadable(
    () => import('../pages/EventGroupDetailPage'),
    { fallback: <Loading /> },
);

const AsyncSearchResultsPage = loadable(
    () => import('../pages/SearchResultsPage'),
    { fallback: <Loading /> },
);

const AsyncCategoryPage = loadable(
    () => import('../pages/CategoryPage'),
    { fallback: <Loading /> },
);

const AsyncTopEventsPage = loadable(
    () => import('../pages/TopEventsPage'),
    { fallback: <Loading /> },
);

const AsyncTopEventsOtherCountriesPage = loadable(
    () => import('../pages/TopEventsOtherCountriesPage'),
    { fallback: <Loading /> },
);

const AsyncCheckoutPage = loadable(
    () => import('../pages/CheckoutPage').then((module) => {
        const CheckoutPage = module.default;
        function CheckoutRoute(props) {
            return (
                <CheckoutPage
                    {...props}
                    onSubmitted={navigateToPaymentGateway}
                />
            );
        }
        return { default: CheckoutRoute };
    }),
    { fallback: <Loading /> },
);

const AsyncNotFoundPage = loadable(
    () => import('../pages/NotFoundPage'),
    { fallback: <Loading /> },
);

export const HOME_PATH = '/';
export const CHECKOUT_PATH = '/checkout';
export const EVENT_DETAIL_PATH = '/event/:slug';
export const EVENT_GROUP_DETAIL_PATH = '/event-group/:slug';
export const SEARCH_PATH = '/search';
export const TOP_EVENTS_PATH = '/top-events';
export const TOP_EVENTS_OTHER_COUNTRIES_PATH = '/top-other-countries-events';

const routes = [
    {
        id: 'event_detail',
        path: EVENT_DETAIL_PATH,
        exact: true,
        component: AsyncEventDetailPage,
    },
    {
        id: 'event_group_detail',
        path: EVENT_GROUP_DETAIL_PATH,
        exact: true,
        component: AsyncEventGroupDetailPage,
    },
    {
        id: 'search',
        path: SEARCH_PATH,
        exact: true,
        component: AsyncSearchResultsPage,
    },
    {
        id: 'category',
        path: '/category/:id',
        exact: true,
        component: AsyncCategoryPage,
    },
    {
        id: 'top_events',
        path: TOP_EVENTS_PATH,
        exact: true,
        component: AsyncTopEventsPage,
    },
    {
        id: 'top_events_other_countries',
        path: TOP_EVENTS_OTHER_COUNTRIES_PATH,
        exact: true,
        component: AsyncTopEventsOtherCountriesPage,
    },
    {
        id: 'checkout',
        path: CHECKOUT_PATH,
        exact: true,
        component: AsyncCheckoutPage,
    },
    {
        id: 'home',
        path: HOME_PATH,
        exact: true,
        component: AsyncHomePage,
    },
    {
        id: 'not_found',
        component: AsyncNotFoundPage,
    },
];

export default routes;
